import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, EMPTY, forkJoin, Observable, of, switchMap } from 'rxjs';
// import { MessagesService } from '@sbd-account-portal/app/layout/common/messages/messages.service';
import { NavigationService } from '@sbd-account-portal/app/core/navigation/navigation.service';
// import { NotificationsService } from '@sbd-account-portal/app/layout/common/notifications/notifications.service';
// import { QuickChatService } from '@sbd-account-portal/app/layout/common/quick-chat/quick-chat.service';
// import { ShortcutsService } from '@sbd-account-portal/app/layout/common/shortcuts/shortcuts.service';
import { UserService } from './core/user/user.service';
import { LegalTermService } from '@sbd-account-portal/app/modules/terms-review/legal-term.service';

@Injectable({
  providedIn: 'root',
})
export class InitialDataResolver implements Resolve<any> {
  private _router = inject(Router);

  /**
   * Constructorapp
   */
  constructor(
    // private _messagesService: MessagesService,
    private _navigationService: NavigationService,
    // private _notificationsService: NotificationsService,
    // private _quickChatService: QuickChatService,
    // private _shortcutsService: ShortcutsService,
    private _userService: UserService,
    private _legalTermService: LegalTermService,
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Use this resolver to resolve initial mock-api for the application
   *
   * @param _route
   * @param _state
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<unknown> {
// In apps/account-portal/src/app/app.resolvers.ts

    return this._legalTermService.getLegalTerms().pipe(
      switchMap(terms => {
        if (terms?.length > 0) {
          this._router.navigate(['/terms-review']);
          return EMPTY;
        }

        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
          this._navigationService.get(),
          this._userService.get(),
        ]);
      }),
      catchError(error => {
        console.error('Error in resolver:', error);
        return of(null);
      }),
    );
  }
}
